import * as d3 from "d3";

export default class TimeWheel {
  #svgId;
  #svgTimer!: NodeJS.Timeout; // The whole Wheel
  #timeoutSelected!: NodeJS.Timeout;
  #selectedTime!: string;
  #selectedUntilTime!: string | null;
  #timeoutSelectedUntil!: NodeJS.Timeout; // ID of the second timeout
  #flagSelectedUntilTime;
  #allowSelection;
  #data;
  #correspondingAngle: [number, number][];
  #pie: any;
  #color: string;
  #arcGenerator: d3.Arc<any, d3.DefaultArcObject>;

  constructor(id: number) {
    this.#svgId = "time" + id;
    this.#selectedTime = $("#year-from").attr("data-year")!;
    this.#data = d3.range(2010, 2024, 1);
    this.#correspondingAngle = [
      [4.7123613357543945, 5.270867347717285],       // 2010
      [5.270867347717286, 5.829373359680176],       // 2011
      [5.829373359680177, 0.13962650299072265],     // 2012
      [0.13962650299072266, 0.6981065273284912],    // 2013
      [0.6981065273284913, 1.2566096782684326],     // 2014
      [1.2566096782684327, 1.8500182628631592],     // 2015
      [1.8500182628631593, 2.408522844314575],      // 2016
      [2.408522844314576, 2.967026948928833],       // 2017
      [2.967026948928834, 3.560438871383667],       // 2018
      [3.560438871383668, 4.1189422607421875],      // 2019
      [4.1189422607421875, 4.2672970107],           // 2020
      [4.2672970107, 4.41565176145],                // 2021
      [4.41565176145, 4.5640065122],                // 2022
      [4.5640065122, 4.71236126295]                 // 2023
    ];
    this.#color = "#ffffff";
    this.#pie = d3
      .pie()
      .sort(null)
      .value(function (d) {
        return 10;
      });
    this.#arcGenerator = d3.arc().innerRadius(72).outerRadius(120);
    this.#flagSelectedUntilTime = false;
    this.#allowSelection = true;
  }

  addWheel(x: number, y: number, angle: number) {
    this.#selectedUntilTime = null;
    this.#allowSelection = true;

    var svg = d3.select("#" + this.#svgId).empty()
      ? d3.select("#yearWheelMenu").append("svg")
      : d3.select("#" + this.#svgId);
    var screenX = window.innerWidth * x;
    var screenY = window.innerHeight * y;

    this.#flagSelectedUntilTime = false;

    svg
      .attr("id", this.#svgId)
      // @ts-ignore
      .attr("width", window.innerWidth)
      .attr("height", window.innerHeight);

    //this.removeAfterDelay();

    var g = svg
      .selectAll("arc" as any)
      // @ts-ignore
      .data(this.#pie(this.#data))
      // @ts-ignore
      .enter()
      .append("g")
      .attr("transform", "translate(" + screenX + "," + screenY + ")");

    g.append("path")
      .attr("d", this.#arcGenerator)
      .attr("fill", this.#color)
      .attr("stroke", "black")
      .style("stroke-width", "2px")
      .style("opacity", 0.7);

    g.append("text")
      .attr(
        "transform",
        (d: any) => "translate(" + this.#arcGenerator.centroid(d) + ")"
      )
      .attr("text-anchor", "middle")
      .style("fill", "#000000")
      .text((d: any) => d.data);
  }

  updateWheel(x: number, y: number, angle: number) {
    var svg = d3.select("#" + this.#svgId);

    if (svg.empty()) {
      this.addWheel(x, y, angle);
      return;
    }

    var screenX = window.innerWidth * x;
    var screenY = window.innerHeight * y;

    //this.removeAfterDelay();

    svg
      .selectAll("g")
      .attr("transform", "translate(" + screenX + "," + screenY + ")");
    svg
      .selectAll("g.popUp") // This selects only elements with the 'scaled' class
      .attr(
        "transform",
        "translate(" + screenX + "," + screenY + ") scale(1.2)"
      );

    if (!this.#allowSelection) {
      return;
    }

    //On the second select time
    if (this.#flagSelectedUntilTime) {
      var highlightedIndex = this.getHighlightedIndex(angle);
      var selectedIndex = this.#data.indexOf(Number(this.#selectedTime));

      //Prevent selection of same or previous year
      if (highlightedIndex <= selectedIndex) {
        return;
      }

      svg.selectAll("path").attr("class", (d, i) => {
        return i === highlightedIndex ? "highlight" : "";
      });

      if (this.#timeoutSelectedUntil) {
        clearTimeout(this.#timeoutSelectedUntil);
      }

      this.#timeoutSelectedUntil = setTimeout(() => {
        this.runDelayedAnimation(screenX, screenY, angle);
        svg.selectAll("path").attr("class", "");
        this.#selectedUntilTime = this.#data[highlightedIndex].toString();
        this.updateUi();
      }, 2500);

      return;
    }

    svg.selectAll("path").style("fill", "white");
    svg.selectAll("text").style("fill", "#000000");

    var highlightedIndex = this.getHighlightedIndex(angle);
    svg.selectAll("path").attr("class", (d, i) => {
      return i === highlightedIndex ? "highlight" : "";
    });

    this.#selectedTime = this.#data[highlightedIndex].toString();

    if (this.#timeoutSelected) {
      clearTimeout(this.#timeoutSelected);
    }

    this.#timeoutSelected = setTimeout(() => {
      this.runDelayedAnimation(screenX, screenY, angle);
      this.updateUi();
    }, 2500);
  }

  updateUi() {
    $("#year-from").text(this.#selectedTime || "");
    $("#year-from").attr("data-year", this.#selectedTime || "");

    if (this.#selectedUntilTime) {
      $("#year-text-from").show();
      $("#year-text-until").show();
      $("#year-until").text(this.#selectedUntilTime);
      $("#year-until").attr("data-year", this.#selectedUntilTime);
      $("#indicatorsBuildings").css({
        "pointer-events": "none",
        opacity: "0.4",
      });
    } else {
      $("#year-text-from").hide();
      $("#year-text-until").hide();
      $("#year-until").text("");
      $("#year-until").attr("data-year", "");
      $("#indicatorsBuildings").css("pointer-events", "").css("opacity", "");
    }
  }

  removeWheel() {
    d3.select("#" + this.#svgId).remove();
  }

  removeAfterDelay() {
    clearTimeout(this.#svgTimer);

    this.#svgTimer = setTimeout(() => {
      d3.select("#" + this.#svgId).remove();
    }, 7000);
  }

  getHighlightedIndex(angle: number) {
    return this.#correspondingAngle.findIndex(([startAngle, endAngle]) => {
      if (endAngle < startAngle) {
        // wrap-around scenario
        return angle >= startAngle || angle <= endAngle;
      } else {
        return angle >= startAngle && angle <= endAngle;
      }
    });
  }

  runDelayedAnimation(screenX: number, screenY: number, angle: number) {
    var svg = d3.select("#" + this.#svgId);
    var highlightedIndex = this.getHighlightedIndex(angle);

    var gSelected = svg
      .selectAll("g")
      .filter((d, i) => i === highlightedIndex)
      .classed("popUp", true);

    gSelected
      .transition()
      .duration(500)
      .attr(
        "transform",
        "translate(" + screenX + "," + screenY + ") scale(1.2)"
      )
      .on("end", () => {
        gSelected
          .selectAll("path")
          .transition()
          .duration(250)
          .style("fill", "black");
        gSelected
          .selectAll("text")
          .transition()
          .duration(250)
          .style("fill", "white");
        //Get the indexes of all the previous years
        var yearG = svg.selectAll("g").filter((_, i) => i < highlightedIndex);

        if (this.#selectedTime !== this.#data[highlightedIndex].toString()) {
          var selectedIndex = this.#data.indexOf(Number(this.#selectedTime));
          var gAllYears = svg.selectAll("g");

          yearG = gAllYears.filter(
            (_, i) => i !== selectedIndex && i !== highlightedIndex
          );
          this.#allowSelection = false;
        }

        yearG
          .selectAll("path")
          .transition()
          .duration(250)
          .style("opacity", 0.2);
        yearG
          .selectAll("text")
          .transition()
          .duration(250)
          .style("opacity", 0.2);
        this.#flagSelectedUntilTime = true;
      });
  }
}
